export * from './doctor-quick-prescription-details.service';